module.exports = __webpack_public_path__ + "img/DOCUMENTATION.9e5ce8a9.svg";